import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { User, Webinar, WebinarClient, WebinarReview, WebinarReviewHelpScore } from '../Services/WOWApi.Service';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';
import { HttpErrorResponse } from '@angular/common/http';
import { openConfirmDialog } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { WebinarImagesComponent } from './webinar-images/webinar-images.component';

@Component({
    selector: 'app-webinar',
    templateUrl: './webinar.component.html',
    styleUrls: ['./webinar.component.css'],
    providers: [NgbCarouselConfig],
    standalone: false
})
export class WebinarComponent implements OnInit {
  avatarImg = '../../assets/Images/demo.png';
  webinar: Webinar;
  WebinarId: number;
  RequestedQuantity: number;
  showSpinner: boolean = false;
  seatsLeft:number;
  isMobileView = false;
  subscription: Subscription;
  totalReviews: number;
  reviewInput: string = '';
  reviewList: WebinarReview[] = [];
  user: User;
  reviewForEdit: WebinarReview;
  isUpdatingReview = false;
  webinarImagesUrls: string[] = [];

  constructor(private webinarClient: WebinarClient,
    private activatedRoute: ActivatedRoute,
    private router: Router, 
    private commonService: CommonService,
    private dialog: MatDialog) {
      this.commonService.setSpinner(true);
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('UserInfo'));
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.showSpinner = true;
    this.WebinarId = this.activatedRoute.snapshot.params.id;
    this.GetWebinar();
    this.commonService.setcurrentWebinarSurfed(this.WebinarId);
  }
  GetWebinar() {
    this.webinarClient.getWebinar(this.WebinarId).subscribe(data => {
      data.pricePerSeat = Number(data.pricePerSeat.toFixed(2));
      this.webinar = data;
      this.seatsLeft = this.webinar.webinarSeats.filter(x => x.statusId ==1).length;
      this.totalReviews = (this.webinar.webinarReviews.length > 0) ? this.webinar.webinarReviews.length : 0;
      this.RequestedQuantity = 1;
      this.reviewList = this.webinar.webinarReviews;
      this.showSpinner = false;
      this.webinar.webinarImages.map(img => {
        this.webinarImagesUrls.push(this.getWebImage(img.image));
      })
    }, error => { this.showSpinner = false; });
  }
  ChangeQuantity(increaseQuantity: boolean) {
    if (increaseQuantity) {
      this.RequestedQuantity = this.RequestedQuantity + 1;
    }
    else if (!increaseQuantity) {
      if (this.RequestedQuantity > 1)
        this.RequestedQuantity = this.RequestedQuantity - 1;
    }

  }

  PurchaseSeats() {
    this.router.navigate(["/Seat-Purchase", this.WebinarId]);
  }

  getWebImage(base64String) {
    return 'data:image/jpg;base64,' + base64String;
  }

  postComment(webinar: Webinar) {
    let review: any = new WebinarReview();
    review = {
      reviewComment: this.reviewInput,
      reviewerEmailId: this.user.emailId,
      reviewDate: new Date(),
      reviewerName: this.user.firstName + ' ' + this.user.lastName,
      webinarId: webinar.webinarId
    }
    this.showSpinner = true;
    this.webinarClient.createWebinarReview(review).subscribe(res => {
      let reviews: WebinarReview[] = [];
      reviews = JSON.parse(JSON.stringify(this.reviewList));
      reviews.push(res);
      this.reviewList = [];
      this.reviewList = reviews;
      this.reviewInput = '';
      this.showSpinner = false;
      this.totalReviews += 1;
    }, error => {
      this.showSpinner = false;
    });
  }

  getPositiveHelpScore(review: WebinarReview): Number {
    const count = review.webinarReviewHelpScores.filter(x => x.isHelpful === true).length;
    return (review !== undefined && review.webinarReviewHelpScores !== undefined && review.webinarReviewHelpScores !== null) ? count : 0;
  }

  getNegativeHelpScore(review: WebinarReview): Number {
    const count = review.webinarReviewHelpScores.filter(x => x.isHelpful === false).length;
    return (review !== undefined && review.webinarReviewHelpScores !== undefined && review.webinarReviewHelpScores !== null) ? count : 0;
  }

  isAlreadyVotedPositive(review: WebinarReview): boolean {
    if (this.user === null || this.user === undefined) {
      return false;
    }
    return review.webinarReviewHelpScores.some(x => x.byEmail === this.user.emailId && x.isHelpful === true) ? true : false;
  }

  isAlreadyVotedNegative(review: WebinarReview): boolean {
    if (this.user === null || this.user === undefined) {
      return false;
    }
    return review.webinarReviewHelpScores.some(x => x.byEmail === this.user.emailId && x.isHelpful === false) ? true : false;
  }

  onAddWebinarHelpScore(review: WebinarReview, score: boolean) {
    const scoreObj: any = {
      byEmail: this.user.emailId,
      isHelpful: score,
      reviewId: review.id,
    }
    this.showSpinner = true;
    this.webinarClient.createReviewHelpScore(scoreObj).subscribe(res => {
      const obj = JSON.parse(JSON.stringify(res));
      this.actionAfterResponseHelpScoreOnAdd(obj);
      this.showSpinner = false;
    }, (error: HttpErrorResponse) => {
      console.log(error.message);
      console.log('Opionon already added against review');
      this.showSpinner = false;
    });

  }

  onRemoveWebinarHelpScore(review: WebinarReview) {
    const scoreId = review.webinarReviewHelpScores.find(x => x.byEmail === this.user.emailId).id;
    this.showSpinner = true;
    this.webinarClient.deleteReviewHelpScore(scoreId).subscribe(res => {
      if (res === true) {
        this.actionAfterResponseHelpScoreOnRemove(scoreId, review.id);
      }
      this.showSpinner = false;
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.showSpinner = false;
    });
  }

  actionAfterResponseHelpScoreOnAdd(scoreObj: WebinarReviewHelpScore) {
    const reviews: any = JSON.parse(JSON.stringify(this.reviewList));
    const reivewScoreObjs: WebinarReviewHelpScore[] = JSON.parse(JSON.stringify(reviews.find(x => x.id === scoreObj.reviewId).webinarReviewHelpScores));
    this.reviewList = [];
    const reviewIdx = reviews.findIndex(x => x.id === scoreObj.reviewId);
    reivewScoreObjs.push(scoreObj)
    reviews[reviewIdx].webinarReviewHelpScores = [];
    reviews[reviewIdx].webinarReviewHelpScores = reivewScoreObjs;
    this.reviewList = reviews;
  }

  actionAfterResponseHelpScoreOnRemove(scoreId: number, reviewId: number) {
    const reviews = JSON.parse(JSON.stringify(this.reviewList));
    const scoreIdx = reviews.find(x => x.id === reviewId).webinarReviewHelpScores.findIndex(x => x.id === scoreId);
    this.reviewList = [];
    reviews.find(x => x.id === reviewId).webinarReviewHelpScores.splice(scoreIdx, 1);
    this.reviewList = reviews;
  }

  updateReview(review: WebinarReview) {
    this.reviewForEdit = review;
    this.reviewInput = review.reviewComment;
    this.isUpdatingReview = true;
  }

  onUpdateCancel() {
    this.isUpdatingReview = false;
    this.reviewForEdit = undefined;
    this.reviewInput = '';
  }

  onUpdateCommentPost() {
    this.reviewForEdit.reviewComment = this.reviewInput;
    this.showSpinner = true;
    this.webinarClient.updateWebinarReview(this.reviewForEdit).subscribe(res => {
      if (res === true) {
        const idx = this.reviewList.findIndex(x => x.id ===this.reviewForEdit.id);
        this.reviewList[idx] = this.reviewForEdit;
        this.onUpdateCancel();
      }
      this.showSpinner = false;
    }, error => {
      console.log(error.error);
      this.showSpinner = false;
    })
  }

  deleteReview(review: WebinarReview) {
    openConfirmDialog(this.dialog, {
        message: 'Are you sure, you want to delete the review ?',
        buttonText: {
          ok: 'Yes, Delete',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.showSpinner = true;
        this.webinarClient.deleteWebinarReview(review.id).subscribe(res => {
          if (res === true) {
            const idx = this.reviewList.findIndex(x => x.id === review.id);
            this.reviewList.splice(idx, 1);
            this.totalReviews -= 1;
          }
          this.showSpinner = false;
        }, error => {
          console.log(error);
          this.showSpinner = false;
        })
      }
    })
  }
  
  isReviewOwner(review: WebinarReview) {
    if (this.user === null || this.user === undefined) {
      return false;
    }
    return (review.reviewerEmailId === this.user.emailId) ? true : false;
  }

  isDeleteAllowed(review: WebinarReview) {
    if (this.user === null || this.user === undefined) {
      return false;
    }
    return (review.reviewerEmailId === this.user.emailId) ? true : false;
    // return (review.reviewerEmailId === this.user.emailId && !review.webinarReviewHelpScores.some(x => x.byEmail === this.user.emailId)) ? true : false;
  }

  opneWebinarImages() {
    this.dialog.open(WebinarImagesComponent, {
      height: '80vh',
      width: '80vw',
      maxWidth: '96vw',
      panelClass: 'webinar-images-dialog-panel',
      backdropClass: 'confirm-dialog-backdrop',
      autoFocus: false,
      data: this.webinarImagesUrls
    });
  }

  get isFree(): boolean {
    return !!this.webinar?.isFreeBee || Number(this.webinar?.pricePerSeat) === 0;
  }

  get displayPrice(): string {
    if (!this.webinar) {
      return '';
    }
    if (this.isFree) {
      return 'FREE';
    }
    return `$${this.displayPriceAmount}`;
  }

  get displayPriceAmount(): string {
    if (!this.webinar) {
      return '';
    }
    if (this.isFree) {
      return 'FREE';
    }
    const amount = Number(this.webinar.pricePerSeat);
    if (!Number.isFinite(amount)) {
      return '0';
    }
    return amount % 1 === 0 ? `${amount}` : amount.toFixed(2);
  }

  get accountSeatLimit(): number {
    const limit = Number(this.webinar?.maxSeatsAllowedPerUser);
    if (Number.isFinite(limit) && limit > 0) {
      return limit;
    }
    return Number(this.webinar?.numberOfSeats) || 0;
  }

  get hasPerAccountCap(): boolean {
    const total = Number(this.webinar?.numberOfSeats) || 0;
    return this.accountSeatLimit > 0 && this.accountSeatLimit < total;
  }

  get seatsTaken(): number {
    if (!this.webinar) {
      return 0;
    }
    return Math.max(0, (this.webinar.numberOfSeats || 0) - (this.seatsLeft || 0));
  }

  get fillPercent(): number {
    const total = this.webinar?.numberOfSeats || 0;
    if (!total) {
      return 0;
    }
    return Math.min(100, Math.round((this.seatsTaken / total) * 100));
  }

  get isLowSeats(): boolean {
    const total = this.webinar?.numberOfSeats || 0;
    if (!total) {
      return false;
    }
    return (this.seatsLeft || 0) / total <= 0.25;
  }

  get isSoldOut(): boolean {
    return (this.seatsLeft || 0) <= 0;
  }

  videoLengthLabel(seconds: number): string {
    const total = Math.max(0, Math.floor(Number(seconds) || 0));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const rest = total % 60;
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    if (minutes > 0) {
      return rest ? `${minutes}m ${rest}s` : `${minutes}m`;
    }
    return `${rest}s`;
  }
}
